import { Box, Input, Stack } from "flicket-ui";
import { CSSProperties, ReactNode } from "react";
import { FixedRatioImage, SlateRenderer } from "~components";
import Modal, { ModalProps } from "~components/common/Modal";
import { ImageGalleryFragmentFragment } from "~graphql/sdk";
import { useIsMobile } from "~hooks";
import { hasRichTextContent } from "~lib/helpers/hasRichTextContent";

interface IZoneModal extends Pick<ModalProps, "isOpen" | "close"> {
  imageGallery: ImageGalleryFragmentFragment[];
  title: string;
  description: string;
  stickySection: ReactNode;
  footer?: ReactNode;
  aspectRatio?: CSSProperties["aspectRatio"];
}

export const DetailsModal = (props: IZoneModal) => {
  return (
    <Modal
      alignModalTop={true}
      isOpen={props.isOpen}
      close={props.close}
      maxWidth="100%"
      width="100%"
      clickOutsideToClose={true}
    >
      <ModalContent {...props} />
    </Modal>
  );
};

function ModalContent(props: IZoneModal) {
  const {
    imageGallery,
    title,
    description,
    stickySection,
    footer,
    aspectRatio = "3 / 2",
  } = props;

  return (
    <>
      {/* Hack to not have the numeric stepper input autofocused on launch */}
      <Input
        autoFocus={true}
        position="absolute"
        opacity={0}
        pointerEvents="none"
      />

      {imageGallery?.[0] && (
        <Box
          p={{ _: 0, sm: 0 }}
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
        >
          <FixedRatioImage
            src={imageGallery?.[0].original.src}
            alt={title}
            aspectRatio={aspectRatio}
            width={{ _: "100%" }}
            // borderRadius={{ sm: "6px 0 0 0px" } as any}
            backgroundColor="N100"
            objectFit="cover"
          />
        </Box>
      )}

      <Modal.Content p={0} pb={6} position="relative">
        {imageGallery?.[0] && (
          <Box p={{ _: 0, sm: 0 }} opacity={0}>
            <FixedRatioImage
              src={imageGallery?.[0].original.src}
              alt={title}
              aspectRatio={aspectRatio}
              width={{ _: "100%" }}
              // borderRadius={{ sm: "6px 0 0 0px" } as any}
              backgroundColor="N100"
              objectFit="cover"
            />
          </Box>
        )}
        <Box px={{ _: 2, sm: 4 }} backgroundColor="white" zIndex={9}>
          <Stack
            direction="horizontal"
            gap={3}
            justifyContent="space-between"
            flex={1}
            py={4}
            boxShadow={"none"}
            // borderBottom="1px solid #E5E5E5"
          >
            {typeof stickySection === "function"
              ? stickySection({ isSticky: false })
              : stickySection}
          </Stack>
        </Box>

        {hasRichTextContent(description) && (
          <Box mt={0} px={{ _: 2, sm: 4 }} backgroundColor="white">
            <SlateRenderer value={description} />
          </Box>
        )}
      </Modal.Content>
      {footer && <Modal.Footer boxShadow="card">{footer}</Modal.Footer>}
    </>
  );
}
